import type { Thunk, Action } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { Injections } from '../services/injections';
import type { ManifestEventResponse, EventSearchParams } from '../services/ScheduleService/types';
import type { StoreModel } from '..';

export interface ManifestModel {
  manifestEvents: ManifestEventResponse[];
  setManifestEvents: Action<ManifestModel, ManifestEventResponse[]>;
  searchAllManifestScheduleEvents: Thunk<
    ManifestModel,
    EventSearchParams,
    Injections,
    StoreModel,
    Promise<ManifestEventResponse[]>
  >;
}

export const manifestModel: ManifestModel = {
  manifestEvents: [],
  setManifestEvents: action((state, payload) => {
    state.manifestEvents = payload;
  }),
  searchAllManifestScheduleEvents: thunk(async (actions, payload, { injections }) => {
    const { scheduleService } = injections;
    try {
      const response = await scheduleService.searchAllManifestScheduleEvents(payload);
      actions.setManifestEvents(response);
      return response;
    } catch (error) {
      return error;
    }
  }),
};
